import React from "react";
import './newMenuCard.css'
import SelectItems from "./SelectItem";
import Favorite from "./Favorite";
import { useDispatch, useSelector } from "react-redux";
import Note from "./Note";

const MenuCard = ({ cartKey, menuId, src , title, typeIcons = [], dietIcon, description, price, tab,unit, currency = '₹', ActionComponent, isAvailable, showNote,note,tableName }) => {

    const cart = useSelector((state) => state?.user?.cart);
    console.log("dietIcon",dietIcon)
     console.log("cart........",cart)
     console.log("MenuCard cartKey........",cartKey)
     console.log("menuId........",menuId)
    return (<li className={isAvailable ? '' : 'over'}>
        <div className="menuCard" >
            {/* <div className="menuImage">
                <Favorite menuId={menuId} />
                <img src={src} title="" alt="" className="itemImage" />
            </div> */}
            <div className="menuText">
                <div>
                    <div className="menuTitle">
                        <div className="dietIcon">
                            <img src={dietIcon} title="" alt="" className="" />
                        </div>
                        {title}
                        {typeIcons.map(typeIcon => typeIcon)}
                    </div>
                    {/* <div className="menuDescription">{description}</div> */}
                </div>
                <div className="menuPrice">{currency}{price}</div>

                {showNote === true && (
                        <Note id={cartKey} tab={tab} title={title} note={note} tableName={tableName}/>
              )}

            </div>
            {ActionComponent &&
                <div className="menuSelectItem">
                    {/* <SelectItems menuId={menuId} unit={cart[menuId]} tab={tab} /> */}
                    <ActionComponent menuId={menuId} unit={unit || cart[menuId]} tab={tab} isAvailable={isAvailable} tableName={tableName}  />
                </div>}
        </div>
    </li>)
}

export default MenuCard;